import { createContext, useState, useContext, useEffect, useCallback } from 'react';
 import { useGoogleLogin, googleLogout} from '@react-oauth/google';
import {getUser, getUserByRememberMe} from './Utils';
import {useConfig} from "../helpers/useConfig";
import {jwtDecode} from "jwt-decode";
import Cookies from 'js-cookie';

export const CurrentUserContext = createContext();
export const CurrentUserProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [userIsLoading, setLoading] = useState(true); 
    const {configData, setConfig} = useConfig();
    const handleGoogleSuccess = useCallback((response) => {
      // Extract user data from the Google response
      const userData = {
        // Map Google response data to your user object structure
        id: response.profileObj.googleId,
        name: response.profileObj.name,
        email: response.profileObj.email,
        // ...
      };
      console.log("ID: " + response.profileObj.sub);
      console.log('Full Name: ' + response.profileObj.name);
      console.log('Given Name: ' + response.profileObj.given_name);
      console.log('Family Name: ' + response.profileObj.family_name);
      console.log("Image URL: " + response.profileObj.picture);
      console.log("Email: " + response.profileObj.email);
      loginSuccess(userData); // Call the login function from UserContext
    }, []);

    function google_to_signup(){
        localStorage.setItem("g_state", "signup");
    }
    function google_to_signin(){
        localStorage.setItem("g_state", "signin");
    }

    const googleLogin = useGoogleLogin({
      onSuccess: handleGoogleSuccess,
      // ... other configuration
    });

    const fetchCurrentUser = async (lang) => {
      var userObj;
      var g_email = localStorage.getItem("g_email");
      var rememberme = Cookies.get('rememberme');
      //rememberme = '%2BixPA4ACcsTvtF%2BIlK1ZigFZ%2BHY%3D';
      if (g_email)
         userObj = await getUser(lang, g_email);
      else
         userObj = await getUserByRememberMe(lang, rememberme);

      console.log('fetchCurrentUser', userObj.user);
      if (userObj.user.loggedin) {
          setCurrentUser(userObj.user)
          localStorage.setItem("currentUser", JSON.stringify(userObj.user));
      } 
      else
        console.log('user is not logged in');
    }
  
    
    const loginSuccess = useCallback((credentialResponse) => {
    if (credentialResponse?.credential) {
      try {
        const decoded = jwtDecode(credentialResponse.credential);    
        localStorage.setItem("currentGoogleUser", JSON.stringify(decoded));
        localStorage.setItem("g_email", decoded.email);
        localStorage.setItem("g_name", decoded.given_name);
        var lang = configData.lang;
        fetchCurrentUser(lang);
      } catch (err) {
        console.error("Failed to decode Google token", err);
      }
    }
  }, []);

    const logout = useCallback(() => {
      //googleLogout();
      setCurrentUser(null);
      localStorage.removeItem("g_email");
      localStorage.removeItem("g_name");
      localStorage.removeItem("currentUser");
      
    }, []);

      // Effect to load user from storage on initial render
    useEffect(() => {
      // Load user from localStorage/sessionStorage if present
      var g_email = localStorage.getItem("g_email");
      var g_state = localStorage.getItem("g_state");
      console.log("logged in google account: " + g_email); 
      const storedUser = localStorage.getItem("currentUser");
      console.log("storedUser: ",  storedUser); 
      if (storedUser) {
        fetchCurrentUser(configData.lang);
      }
      setLoading(false);
      console.log("user loaded");
    }, []);

    return (
      
          <CurrentUserContext.Provider value={{ currentUser, loginSuccess, logout, googleLogin, fetchCurrentUser, google_to_signup, google_to_signin, userIsLoading }}>
            {children}
          </CurrentUserContext.Provider>
      
      
    )
  }
  
  export const useCurrentUser = () => useContext(CurrentUserContext)